import styled from '@emotion/styled';
import { GlobalAlertModal } from 'components/GlobalAlertModal';
import afternoon from 'images/splash-afternoon.jpg';
import { ReactNode } from 'react';
import tw from 'twin.macro';

interface LayoutProps {
  children: ReactNode;
}

const Container = styled.div`
  ${tw`flex items-center justify-center h-screen overflow-hidden bg-s-neutral-subdued-light lg:justify-start lg:px-28`};
  background-image: url(afternoon);
`;

const ImageContainer = styled.div`
  ${tw`absolute inset-0`};
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

function Component(props: LayoutProps) {
  const { children } = props;

  return (
    <>
      <Container>
        <ImageContainer>
          <img alt="afternoon" src={afternoon} />
        </ImageContainer>
        {children}
      </Container>
      <GlobalAlertModal />
    </>
  );
}

export const Layout = Component;
